import * as i0 from '@angular/core';
import { inject, Component, Input, NgModule } from '@angular/core';
import * as i2 from '@simpl/element-ng/translate';
import { SiTranslateService, SiTranslateModule } from '@simpl/element-ng/translate';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class SiLanguageSwitcherComponent {
    /**
     * Key for translation.
     * If the key is set to an empty string, the language of the underlaying tanslation framework will not be switched.
     */
    translationKey = 'LANGUAGE';
    /**
     * Text for aria label for the language selector. Needed for a11y
     */
    languageSwitcherLabel = $localize `:@@SI_LANGUAGE_SWITCHER.LABEL:Language switcher`;
    /**
     * List of all available languages in this application.
     */
    set availableLanguages(languages) {
        if (typeof languages[0] !== 'object') {
            languages = languages.map(languageValue => ({
                value: languageValue,
                name: this.translationKey
                    ? `${this.translationKey}.${languageValue.toUpperCase()}`
                    : languageValue
            }));
        }
        this.availableIsoLanguages = languages;
    }
    get availableLanguages() {
        return this.availableIsoLanguages;
    }
    availableIsoLanguages;
    translate = inject(SiTranslateService);
    ngOnInit() {
        this.availableLanguages ??= this.translate.availableLanguages;
    }
    trackByValue = (index, value) => value.value;
    switchLanguage(target) {
        const language = target?.value;
        if (!language || !this.translationKey || this.translationKey.length === 0) {
            return;
        }
        this.translate.setCurrentLanguage(language);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiLanguageSwitcherComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiLanguageSwitcherComponent, selector: "si-language-switcher", inputs: { translationKey: "translationKey", languageSwitcherLabel: "languageSwitcherLabel", availableLanguages: "availableLanguages" }, ngImport: i0, template: "<select\n  class=\"si-title-2 language-switcher-select\"\n  [attr.aria-label]=\"languageSwitcherLabel | translate\"\n  (change)=\"switchLanguage($event.target)\"\n>\n  <option\n    *ngFor=\"let language of availableIsoLanguages; trackBy: trackByValue\"\n    [value]=\"language.value\"\n    [selected]=\"language.value === translate.currentLanguage\"\n  >\n    {{ language.name | translate }}\n  </option>\n</select>\n", styles: [":host{--language-switcher-color: var(--element-text-active)}.language-switcher-select{inline-size:100%;background-color:transparent;border:0;border-block-end:1px solid var(--input-border-color);padding:6px;outline:none;cursor:pointer;color:var(--language-switcher-color)}@media (min-width: 768px){.language-switcher-select{max-inline-size:200px}}.language-switcher-select option{background-color:var(--element-base-1)}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "pipe", type: i2.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiLanguageSwitcherComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-language-switcher', template: "<select\n  class=\"si-title-2 language-switcher-select\"\n  [attr.aria-label]=\"languageSwitcherLabel | translate\"\n  (change)=\"switchLanguage($event.target)\"\n>\n  <option\n    *ngFor=\"let language of availableIsoLanguages; trackBy: trackByValue\"\n    [value]=\"language.value\"\n    [selected]=\"language.value === translate.currentLanguage\"\n  >\n    {{ language.name | translate }}\n  </option>\n</select>\n", styles: [":host{--language-switcher-color: var(--element-text-active)}.language-switcher-select{inline-size:100%;background-color:transparent;border:0;border-block-end:1px solid var(--input-border-color);padding:6px;outline:none;cursor:pointer;color:var(--language-switcher-color)}@media (min-width: 768px){.language-switcher-select{max-inline-size:200px}}.language-switcher-select option{background-color:var(--element-base-1)}\n"] }]
        }], propDecorators: { translationKey: [{
                type: Input
            }], languageSwitcherLabel: [{
                type: Input
            }], availableLanguages: [{
                type: Input
            }] } });

class SiLanguageSwitcherModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiLanguageSwitcherModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiLanguageSwitcherModule, declarations: [SiLanguageSwitcherComponent], imports: [CommonModule, SiTranslateModule], exports: [SiLanguageSwitcherComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiLanguageSwitcherModule, imports: [CommonModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiLanguageSwitcherModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SiTranslateModule],
                    declarations: [SiLanguageSwitcherComponent],
                    exports: [SiLanguageSwitcherComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SiLanguageSwitcherComponent, SiLanguageSwitcherModule };
